var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HearingAbilityContent } from '@/components/hearing-ability-content.component';
import { Button } from '@mui/material';
import { useSimpleModal } from 'hx-ui';
import React from 'react';
export function HearingTestResult(_a) {
    var _b = _a.category, name = _b.name, icon = _b.icon, textColor = _b.textColor, emphasizedText = _b.emphasizedText;
    var _c = useSimpleModal(_jsx(HearingAbilityContent, {}), {
        modalProps: {
            className: 'max-w-[580px]',
        },
    }), modal = _c[0], toggleModal = _c[1];
    return (_jsx("div", __assign({ className: "flex flex-col gap-3 sm:gap-6 items-center py-14" }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-2 bg-faux-white relative text-lg md:text-2xl font-bold shadow-full pt-16 pb-4 px-2 md:px-6 justify-center items-center rounded-3xl w-[85%] max-w-xl/2" }, { children: [_jsxs("div", __assign({ className: "text-center" }, { children: ["Your hearing test results indicate that you may have", ' ', _jsxs("span", __assign({ style: {
                                color: textColor,
                            } }, { children: [emphasizedText, "."] }))] })), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return toggleModal(); } }, { children: "What do my results mean?" })), _jsxs("div", __assign({ className: "absolute top-0 left-1/2 w-24 h-24 -translate-x-1/2 -translate-y-1/2 h-24 w-24" }, { children: [' ', _jsx("img", { src: icon, height: 100, width: 100, alt: "".concat(name, " icon") }), ' '] })), modal] })) })));
}
